module.exports = __webpack_public_path__ + "img/phone-bill-fr.9760cf9b.jpg";